let navbar = document.querySelector('.navbar-anonymous');
if (navbar) {
  let prevScrollpos = window.pageYOffset;
  window.addEventListener('scroll', () => {
    let currentScrollPos = window.pageYOffset;
    if (currentScrollPos > 64) {
      if (prevScrollpos > currentScrollPos) {
        navbar.style.top = '0';
        navbar.classList.add('shadow-sm');
        navbar.classList.add('navbar-narrow');
      }
      else if (prevScrollpos < currentScrollPos) {
        navbar.style.top = -navbar.offsetHeight + 'px';
        navbar.classList.remove('shadow-sm');
      }
    }
    else {
      navbar.classList.remove('shadow-sm');
      navbar.classList.remove('navbar-narrow');
    }
    prevScrollpos = currentScrollPos;
  });
}

function toggleNavbar() {
  if (jQuery('.navbar-button').hasClass('open')) {
    jQuery('.navbar-button').removeClass('open');
    jQuery('.navbar-button').attr('aria-expanded', 'true');
    jQuery('.navbar-collapse').removeClass('show');
    jQuery('header').removeClass('navbar-open');
    jQuery('body').removeClass('navbar-open');
  }
  else {
    jQuery('.navbar-button').addClass('open');
    jQuery('.navbar-button').attr('aria-expanded', 'false');
    jQuery('.navbar-collapse').addClass('show');
    jQuery('header').addClass('navbar-open');
    jQuery('body').addClass('navbar-open');
  }
}

jQuery('.navbar-button').on('click', function () {
  toggleNavbar();
});
